import { roleNames } from '@/constants/role-names';
import { ApplicationRole } from '@/types/application-role';

export const getPlatformAdminRoleId = (
  roles: ApplicationRole[],
): number | undefined =>
  roles.find(({ roleName }) => roleName === roleNames.platformAdmin)?.id;
